import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import useRequestStore from '../../../store/request';
import { useState } from 'react';

export default function RequestProductInfo({ next, back }) {
  const data = useRequestStore((state) => state.data);
  const [product, setProduct] = useState(data.product || 't2w');

  function handleSubmit(evt) {
    evt.preventDefault();
    next({ product });
  }

  function handleBack() {
    back({ product });
  }

  return (
    <Box
      component="form"
      onSubmit={(evt) => handleSubmit(evt)}
      sx={{ display: 'flex', flexFlow: 'column', gap: '16px' }}
    >
      <FormControl>
        <InputLabel id="productLabel">Produkt</InputLabel>
        <Select
          label="Produkt"
          labelId="product"
          value={product}
          onChange={(evt) => setProduct(evt.target.value)}
        >
          <MenuItem value="t2w">Tanss2weclapp-Schnittstelle</MenuItem>
          <MenuItem value="pass">Passwort-Tool</MenuItem>
          <MenuItem value="todo">Todo-Tool</MenuItem>
        </Select>
      </FormControl>
      <Button
        type="submit"
        variant="contained"
        sx={{
          borderRadius: 0,
          color: 'white',
          boxShadow: 'none !important',
          '&:hover': {
            backgroundColor: '#19BB5D',
          },
        }}
      >
        Weiter
      </Button>
      <Button
        onClick={handleBack}
        name="back"
        variant="text"
        sx={{ mt: '-8px' }}
      >
        Zurück
      </Button>
    </Box>
  );
}
